































































































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import Bases from "@/components/designer/sidebar/base/Base.vue";
import Finish from "@/components/designer/sidebar/frame/Finish.vue";
import { mixins } from "vue-class-component";
import { BaseStore, LayoutStore, ShapeStore, FrameStore } from "@/mixins/store";
import { FinishHelpers } from "@/mixins/helpers";
import { BaseModel } from "@/models/products/base";
import {
  Finish as FinishModel,
  FinishHandle,
  FinishDisplayName
} from "@/models/products/finish";
import ProductService from "@/services/product_service";
import UIkit from "uikit";
import { ProductListRes, ProductType } from "@/models/products/product";
import { Collection, ProductLineName } from "@/models/products/collection";
import { UmbrellaType } from "@/models/products/umbrella";
import { APIError, ViewerError } from "@/services/error_service";
import {
  Spigot,
  Stem,
  StemDisplayName
} from "@/models/configurator/configurator_options";
import { StockMixin } from "@/mixins/stock";
import { Accessory } from "@/models/products/accessory";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    Bases,
    Finish
  }
})
export default class BaseSidebar extends mixins(
  BaseStore,
  LayoutStore,
  FrameStore,
  FinishHelpers,
  ShapeStore,
  StockMixin
) {
  @Prop({ default: true }) hasVent!: boolean;
  @Prop({ default: true }) hasValance!: boolean;
  protected ProductLineName = ProductLineName;
  protected selectedBase: BaseModel | null = null;
  protected selectedFinish: FinishModel | null = null;
  protected baseData: null | Collection[] = null;
  protected productService = new ProductService();
  protected FinishHandle = FinishHandle;
  protected selectedStem: Stem | null = null;
  protected selectedWheels: boolean | null = null;
  protected selectedTopCover: null | {
    model: string;
    finish: FinishModel;
  } = null;
  protected selectedSpigot!: Spigot;
  protected Stem = Stem;
  protected baseFilterConfig: {
    global: string[];
    specificMounting: { true: string[]; false: string[] };
    umbrellaType: Partial<Record<UmbrellaType, string[]>>;
    collection: Partial<Record<string, string[]>>;
    hiddenProductLines: string[];
  } = {
    global: [
      // no current model exists:
      "50C",
      "NGU550-E",
      "BZ",
      "XB",
      "XB+C",
      // client business decision to hide from app:
      "8ST",
      "18ST",
      "18ST2",
    ],
    specificMounting: {
      true: [],
      false: []
    },
    umbrellaType: {
      [UmbrellaType.Cantilever]: [],
      [UmbrellaType.Giant]: [],
      // 480 model do not exist yet for market umbrellas, so hiding for now until the script logic is updated and the files are placed on the storage bucket
      [UmbrellaType.Market]: ["480"],
    },
    collection: {
      // [ProductLineName.SomeCollection]: ["someBase"]
    },
    hiddenProductLines: [
      "specialty",
      "in_ground_direct_mount",
    ]
  };

  protected get filteredBases(): string[] {
    const col = this.collection;
    const sets: string[][] = [
      this.baseFilterConfig.global,
      col.specific_mounting
        ? this.baseFilterConfig.specificMounting.true
        : this.baseFilterConfig.specificMounting.false,
      col.umbrella_type
        ? (this.baseFilterConfig.umbrellaType[col.umbrella_type] ?? [])
        : [],
      this.baseFilterConfig.collection[col.handle] ?? []
    ];
    return [...new Set(sets.flat())];
  }
  protected imageOverrideBases = ["NGU550", "XB+C", "480", "DP-SS"]; // uppercase base models that need image overrides
  protected disable = false;

async mounted(): Promise<void> {
  /** Locking down base selection as the models change, as this can cause bugs */
  let modelLoadedListenerRegistered = false;
  EventBus.$on("startModelChange", () => {
    this.disable = true;
    if (!modelLoadedListenerRegistered) {
      modelLoadedListenerRegistered = true;
      this.$viewer.addEventListener("model.loaded", () => {
        this.disable = false;
      });
    }
  });

  const loader = this.$loading.show({
    isFullPage: false,
    container: this.$refs.spinnerContainer
  });
  const data = await this.getBases(loader);
  
  if (!this.collection.specific_mounting) {
    this.baseData = data! as Collection[];
  } else {
    this.baseData = [
      {
        type: ProductType.Base,
        _id: "1",
        display_name: `${this.collection.display_name} bases & mounts`,
        handle: this.collection.handle,
        models: data! as BaseModel[]
      }
    ] as Collection[];
  }
  

  this.baseBusinessLogic();
  this.readStoreData();
  
  this.$nextTick(() => {
    const accordion = this.$el.querySelector('[uk-accordion]');
    if (accordion) {
      // Initialize accordion
      UIkit.accordion(accordion, {
        targets: '> div',
        multiple: true
      });
      
      // Programmatically open first item after slight delay
      setTimeout(() => {
        const items = this.$el.querySelectorAll('.uk-accordion-item');
        if (items.length > 0) {
          UIkit.accordion(accordion).toggle(items[0], true);
        }
      }, 50);
    }
  });
}

  protected hasBaseProTips(baseHandle: Collection["handle"]): boolean {
    const proTipsBaseHandles = ["galvanized_steel_plate", "steel_plate"];
    return proTipsBaseHandles.includes(baseHandle);
  }

  protected verifyImageUrl(url: string): string | null {
    const request = new XMLHttpRequest();
    request.open("HEAD", url, false);
    request.send();
    return request.status === 200 ? url : null;
  }

  /** Specific logic to override base display on specific product lines */
  protected baseBusinessLogic(): void {
    if (this.collection.handle === ProductLineName.Catalina) {
      const availableBasesCatalina = {
        handle: "galvanized_steel_plate",
        models: ["20G-SQ", "24G-SQ", "24G", "30G"]
      };
      this.baseData = this.baseData!.map(base => {
        if (base.handle === availableBasesCatalina.handle) {
          base.models = (base.models as BaseModel[]).filter((b: BaseModel) => {
            if (availableBasesCatalina.models.includes(b.model)) {
              return b;
            }
          }) as BaseModel[];
          return base as Collection;
        } else {
          return base as Collection;
        }
      });
    }
  }

  protected async clearBase(): Promise<void> {
    this.addBase(null);
    this.addBaseFinish(null);
    this.addBaseStem(null);
    this.addBaseOptions(null);
    this.selectedBase = null;
    this.selectedFinish = null;
    this.selectedStem = null;
    this.selectedWheels = null;
    this.selectedTopCover = null;
    await this.$viewer.ChangeBase(null);
  }

  /**
   * Check the store for preset data. If there is none, set default
   * selected model to the first one in model array
   */
  protected readStoreData(): void {
    this.selectedBase = this.baseModel;
    this.selectedFinish = this.baseFinish;
    this.selectedStem = this.baseStem;
    this.selectedWheels = this.baseOptions?.wheels ? true : false;
    this.selectedTopCover = this.baseOptions?.topCover
      ? this.baseOptions?.topCover
      : null;
    this.selectedSpigot = this.spigot;
  }

  protected getStemFromMount(mountModel: string): Stem | null {
    return (Object.values(Stem) as string[]).includes(mountModel)
      ? (mountModel as Stem)
      : null;
  }

  protected getStemDisplayName(stem: Stem | null): string {
    if (!stem) return "";
    const key = (Object.keys(Stem) as Array<keyof typeof Stem>).find(
      k => Stem[k] === stem
    );
    return key ? StemDisplayName[key] : stem;
  }

  protected setDefaultStem(model: BaseModel): void {
    if (this.selectedBase!.model === Stem.Stem18ST2) {
      this.selectedStem = Stem.Stem18ST2;
    } else if (model.mounts && model.mounts.length > 0) {
      const firstStem = this.getStemFromMount(model.mounts[0].model);
      this.addBaseStem(firstStem);
      this.selectedStem = firstStem;
    } else if (
      this.selectedBase!.model &&
      this.selectedBase!.model !== Stem.Stem18ST2 &&
      this.selectedBase!.model.indexOf("18ST2") > -1
    ) {
      // Certain base+18ST2 combinations are a separate product with no stem attribute.
      this.selectedStem = Stem.Stem18ST2;
    } else {
      this.addBaseStem(null);
      this.selectedStem = null;
    }
  }

  protected setDefaultFinish(model: BaseModel): void {
    const orderedFinishes = this.getOrderedFinishes(model.finishes);
    const finish = orderedFinishes[0] ?? null;
    this.selectedFinish = finish;
    this.addBaseFinish(finish);
  }

  protected async getBases(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    loader?: any
  ): Promise<Collection[] | BaseModel[] | undefined> {
    let bases;
    let res: ProductListRes;
    try {
      if (this.collection.specific_mounting) {
        bases = [] as BaseModel[];
        // Fetch the umbrella-specific bases alongside the full base catalog so
        // we can order the flat list by each base's linked product line rather
        // than the umbrella's product line.
        const [umbrellaBasesRes, catalogRes] = await Promise.all([
          this.productService.getBases(this.umbrellaModel?.model),
          this.productService.getBases()
        ]);
        res = umbrellaBasesRes;
        bases = (res.data! as any).bases as BaseModel[];
        bases = bases.filter(
          model => !this.filteredBases.includes(model.model)
        );
        // The umbrella-specific /products/{model}?bases response does not
        // include each base's product line. Use the catalog response, which
        // groups bases under their product line, to build an _id → line-index
        // map so we can sort by base product line instead of umbrella line.
        const baseLines = (catalogRes.data ?? []).filter(
          pl => pl.type === ProductType.Base
        );
        const idToLineIndex = new Map<string, number>();
        baseLines.forEach((pl, lineIdx) => {
          (pl.models as BaseModel[] | undefined)?.forEach(m => {
            idToLineIndex.set(m._id, lineIdx);
          });
        });
        const lineIndex = (model: BaseModel): number => {
          const idx = idToLineIndex.get(model._id);
          return idx === undefined ? baseLines.length : idx;
        };
        bases = (bases as BaseModel[])
          .map((model, i) => ({ model, i }))
          .sort((a, b) => {
            const diff = lineIndex(a.model) - lineIndex(b.model);
            return diff !== 0 ? diff : a.i - b.i;
          })
          .map(entry => entry.model);
        // Eclipse collection: display DP base as "DP-SS" on the frontend
        if (this.collection.handle === ProductLineName.Eclipse) {
          bases = (bases as BaseModel[]).map(model =>
            model.model === "DP" ? { ...model, display_model: "DP-SS" } : model
          );
        }
      } else {
        bases = [] as Collection[];
        res = await this.productService.getBases();
        bases = res.data!.filter(
          (pl: any) =>
            pl.type === ProductType.Base &&
            !this.baseFilterConfig.hiddenProductLines.includes(pl.handle)
        );
        const isMarket = this.collection.umbrella_type === UmbrellaType.Market;
        for (const [i, pl] of (bases as Collection[]).entries()) {
          let models: BaseModel[] = [...pl.models] as BaseModel[];
          models = models.filter(
            model =>
              !model.is_productline_specific &&
              !this.filteredBases.includes(model.model)
          );
          if (isMarket) {
            models = models.map(model => ({
              ...model,
              mounts: (model.mounts ?? []).filter(m => !m.model.includes("2")) // filter out the 2" stems for market umbrellas since they are not compatible with the market line
            }));
          }
          models = models.map(model => ({
            ...model,
            mounts: (model.mounts ?? []).slice().sort((a, b) => {
              const order = [Stem.Stem8ST, Stem.Stem18ST, Stem.Stem18ST2];
              return order.indexOf(a.model as Stem) - order.indexOf(b.model as Stem);
            })
          }));
          (bases as Collection[])[i].models = models;
        }
        bases = (bases as Collection[]).filter(pl => pl.models.length > 0);
      }
      if (loader) {
        loader.hide();
      }
    } catch (err) {
      if (err instanceof APIError) {
        APIError.popup(err.message, err.statusCode);
      }
    }
    return bases;
  }

  protected hasVisibleStemGroup(baseModel: BaseModel | any): boolean {
    if (
      this.collection.handle === ProductLineName.Aurora &&
      (baseModel as BaseModel).model === "36G-SQx2"
    ) {
      return false;
    }
    return true;
  }

  protected async selectBase(
    model: BaseModel,
    finish: FinishModel | null = null,
    stem: Stem | null = null,
    wheels: boolean | null = null,
    topCover: { model: string; finish: FinishModel } | boolean | null = null
  ): Promise<void> {
    this.selectedBase = model;
    let baseOptions: any = {};
    const previousStem = this.selectedStem;
    const newBaseOffersPreviousStem =
      !!previousStem &&
      !!model.mounts &&
      model.mounts.some(m => this.getStemFromMount(m.model) === previousStem);
    if (!stem && newBaseOffersPreviousStem) {
      this.selectedStem = previousStem;
      this.addBaseStem(previousStem);
    } else if (!stem || !model.mounts || (model.mounts && model.mounts.length < 1)) {
      this.setDefaultStem(model);
    } else {
      this.selectedStem = stem;
      this.addBaseStem(stem);
    }
    if (!finish || !model.finishes.includes(finish)) {
      this.setDefaultFinish(model);
    } else {
      this.selectedFinish = finish;
      this.addBaseFinish(finish);
    }
    // @ts-ignore
    if (model.attributes && model.attributes.wheels && !wheels) {
      this.selectedWheels = false;
      // @ts-ignore
    } else if (model.attributes && model.attributes.wheels && wheels) {
      this.selectedWheels = true;
      baseOptions.wheels = this.selectedWheels;
    } else {
      this.selectedWheels = null;
    }
    // @ts-ignore
    if (model.attributes && model.attributes.topCover && topCover) {
      if (
        typeof topCover === "boolean" ||
        (this.baseModel && this.baseModel?._id !== model._id)
      ) {
        // set a default value
        const selectedBaseCover = this.selectedBaseTopCover(model);
        if (!selectedBaseCover) {
          this.selectedTopCover = null;
        } else if (
          this.selectedTopCover &&
          this.selectedTopCover.model === selectedBaseCover.model
        ) {
          // handling repeat button clicks to toggle top cover
          return;
        } else if (this.selectedTopCover) {
          // keep the selected finish, only change the model of the top cover
          this.selectedTopCover.model = selectedBaseCover.model;
        } else {
          this.selectedTopCover = {
            model: selectedBaseCover.model,
            finish: {
              handle: FinishHandle.WG,
              display_name: FinishDisplayName.WG
            }
          };
        }
      } else {
        // topCover is the populated object
        this.selectedTopCover = topCover;
      }
      baseOptions.topCover = this.selectedTopCover;
    } else {
      this.selectedTopCover = null;
    }
    await this.addBaseOptions(baseOptions);
    await this.addBase(model);
    EventBus.$emit("startModelChange");
    await this.sendToViewer(
      typeof wheels === "boolean" ? wheels : null,
      topCover === false ? false : baseOptions.topCover
    );
  }

  protected selectedBaseTopCover(model: BaseModel): Accessory | undefined {
    if (!model.accessories) return undefined;
    return model.accessories.find(accessory => accessory.model.endsWith("-TC"));
  }

  /**
   * The API now uses a unified "IG" model name for in-ground bases across Aurora, Eclipse, and Nova
   * collections. The viewer (MCG.js) still expects the collection-specific legacy names since they
   * map to different mesh families. Translate here before calling ChangeBase.
   */
  protected resolveBaseModelForViewer(model: string | null): string | null {
    if (model === "IG") {
      const handle = this.collection.handle;
      if (handle === ProductLineName.Aurora) return "ARU-IG";
      if (handle === ProductLineName.Eclipse) return "ECU-IG";
      if (handle === ProductLineName.Nova) return "NGU-IG";
    }
    return model;
  }

  protected async sendToViewer(
    wheels: boolean | null,
    topCover: false | any | null = null
  ): Promise<void> {
    let base;
    // Certain base+18ST2 combinations are a separate product with no stem attribute. Detect these bases and set selectedStem to 18ST2 & trim from model name (this is how the viewer accepts this data)
    if (
      this.selectedBase!.model &&
      this.selectedBase!.model !== Stem.Stem18ST2 &&
      this.selectedBase!.model.indexOf("18ST2") > -1
    ) {
      base = this.selectedBase!.model.slice(0, -6);
      this.selectedStem = Stem.Stem18ST2;
    } else if (!this.selectedBase!.model) {
      base = null;
    } else {
      base = this.selectedBase!.model;
    }
    base = this.resolveBaseModelForViewer(base);
    // Strip display-only suffixes before sending to viewer
    if (base && base.endsWith("-SS")) {
      base = base.slice(0, -3);
    }
    try {
      if (this.selectedBase) {
        const stem = this.selectedStem;
        const finish = this.selectedFinish
          ? this.selectedFinish.handle
          : this.selectedBase!.finishes[0].handle;
        const stemFinish = FinishHandle.SS; // Stems 8ST 18ST & 18ST2 all have stainless steel finishes no matter what color the base is in.
        await this.$viewer.ChangeBase(base, finish, stem, stemFinish);
        if (base) {
          if (typeof wheels === "boolean") {
            await this.$viewer.ToggleBaseWheels(wheels);
          }
          if (topCover === false) {
            await this.$viewer.TogglePlateCover(false);
          } else if (topCover) {
            await this.$viewer.TogglePlateCover(true, topCover.finish.handle);
          }
        }
      }
    } catch (err) {
      // console.log(err);
      ViewerError.redirect(err);
    }
  }

  protected toggleBaseModal(id: string): void {
    UIkit.modal(document.getElementById(id) as HTMLElement).show();
  }
  protected getImage(model: BaseModel): string {
    let imageUrl = (model as any).image as string;

    // Base URL setup
    const CDN_URLS = (process.env.VUE_APP_CDN_URL_OPTIONS || "").split(",");
    const matchedUrl =
      CDN_URLS.find((url: string) => imageUrl.includes(url)) ||
      process.env.VUE_APP_CDN_URL;

    if (!matchedUrl) {
      return imageUrl;
    }

    // Replace matched CDN URL or handle relative URLs
    if (imageUrl.includes(matchedUrl)) {
      imageUrl = imageUrl.replace(
        matchedUrl,
        process.env.VUE_APP_CDN_URL || matchedUrl
      );
    } else if (!imageUrl.startsWith("http")) {
      imageUrl = `${process.env.VUE_APP_CDN_URL}/products/bases/${imageUrl}`;
    }
    // Use display_model (e.g. "DP-SS") for image-override lookups when present,
    // since imageOverrideBases is keyed on the displayed name.
    const baseName = (model.display_model || model.model).toUpperCase();
    const isSelectedModel = this.selectedBase?._id === model._id;
    const isListedImgOverrideBase = this.imageOverrideBases.includes(baseName);
    // Default image handling for unselected bases
    if (!isSelectedModel && !isListedImgOverrideBase) {
      return imageUrl;
    }

    const hasDefaultImgOverrideNeeds =
      !isSelectedModel && isListedImgOverrideBase;

    let additionalSuffix = "";

    // Handle special cases for base-specific or umbrella-specific suffix logic
    if (baseName === "480") {
      additionalSuffix = this.get480Suffix(
        baseName,
        hasDefaultImgOverrideNeeds
      );
    } else if (["NGU550", "XB+C"].includes(baseName)) {
      additionalSuffix = this.getSpigotSuffix(
        baseName,
        hasDefaultImgOverrideNeeds
      );
    } else if (baseName === "DP-SS") {
      additionalSuffix = "";
    } else {
      // Add finish and stem for general bases
      const finishSuffix = this.getFinishSuffix(
        hasDefaultImgOverrideNeeds ? baseName : ""
      );
      const stemSuffix = this.selectedStem
        ? `-${String(this.selectedStem).toUpperCase()}`
        : "";
      additionalSuffix = `${finishSuffix}${stemSuffix}`;
    }

    // Remove the plus for XB+C in filenames
    const formattedBaseName =
      baseName === "XB+C" ? baseName.replace("+", "") : baseName;

    const constructedUrl = `${process.env.VUE_APP_CDN_URL}/products/bases/${formattedBaseName}${additionalSuffix}.jpg`;

    return this.verifyImageUrl(constructedUrl) || imageUrl;
  }

  protected getFinishSuffix(modelNameWithImgOverride = ""): string {
    if (modelNameWithImgOverride) {
      let fullBaseModel: any = null;
      this.baseData?.some(
        base =>
          base.models &&
          base.models.some(model => {
            if (model.model.toUpperCase() === modelNameWithImgOverride) {
              fullBaseModel = model;
              return true;
            }
          })
      );
      if (
        fullBaseModel &&
        fullBaseModel.finishes &&
        fullBaseModel.finishes.length > 0
      ) {
        return `-${String(
          this.getOrderedFinishes(fullBaseModel.finishes)[0].handle
        ).toUpperCase()}`;
      }
    } else if (this.selectedFinish) {
      return `-${String(this.selectedFinish.handle).toUpperCase()}`;
    }
    return "";
  }

  protected getSpigotSuffix(baseName: string, isImgOverride = false): string {
    const umbrellaType = this.collection.handle as ProductLineName;

    if (!["NGU550", "XB+C"].includes(baseName)) return "";

    let umbrellaSpecificPrefix = "";

    if (umbrellaType === ProductLineName.Eclipse && baseName === "NGU550") {
      umbrellaSpecificPrefix = "_ECU";
    } else if (umbrellaType === ProductLineName.Aurora && baseName === "XB+C") {
      umbrellaSpecificPrefix = "_ARU";
    }

    let spigotSuffix = "";
    if (this.selectedSpigot === Spigot.StainlessSteel) {
      spigotSuffix = "-SP-SS";
    } else if (this.selectedSpigot === Spigot.Standard) {
      spigotSuffix = "-SP-SM";
    }

    const finishSuffix = this.getFinishSuffix(isImgOverride ? baseName : "");

    return `${finishSuffix}${umbrellaSpecificPrefix}${spigotSuffix}`;
  }

  protected get480Suffix(baseName: string, isImgOverride = false): string {
    const umbrellaType = this.collection.handle as ProductLineName;

    const isMontereyOrGreenwich =
      umbrellaType === ProductLineName.MontereyGSeries ||
      umbrellaType === ProductLineName.GreenwichGSeries;

    const isAuroraOrEclipse =
      umbrellaType === ProductLineName.Aurora ||
      umbrellaType === ProductLineName.Eclipse;

    const finishSuffix = this.getFinishSuffix(isImgOverride ? baseName : "");

    if (isMontereyOrGreenwich) {
      return `${finishSuffix}-${
        this.selectedStem ? String(this.selectedStem).toUpperCase() : "18ST2"
      }`;
    } else if (isAuroraOrEclipse) {
      return `${finishSuffix}`;
    }

    return "";
  }

  /* Not Currently In Use */
  protected getSpecialCaseSuffix(baseName: string): string {
    const specialCases = ["eclipse", "aurora"];
    const isSpecialCase = specialCases.includes(
      this.collection.handle.toLowerCase()
    );
    if (!isSpecialCase) return "";

    let spigotPrefix = "";

    if (baseName === "NGU550") {
      spigotPrefix = "_ECU";
    } else if (baseName === "XB+C") {
      spigotPrefix = "_ARU";
    }

    let spigotSuffix = "";
    if (this.selectedSpigot === Spigot.StainlessSteel) {
      spigotSuffix = "-SP-SS";
    } else if (this.selectedSpigot === Spigot.Standard) {
      spigotSuffix = "-SP-SM";
    }

    return `${spigotPrefix}${spigotSuffix}`;
  }
}
